var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 0.833374H2.33317C1.4165 0.833374 0.666504 1.58337 0.666504 2.50004V14.1667H2.33317V2.50004H12.3332V0.833374ZM11.4998 4.16671L16.4998 9.16671V17.5C16.4998 18.4167 15.7498 19.1667 14.8332 19.1667H5.65817C4.7415 19.1667 3.99984 18.4167 3.99984 17.5L4.00817 5.83337C4.00817 4.91671 4.74984 4.16671 5.6665 4.16671H11.4998ZM10.6665 10H15.2498L10.6665 5.41671V10Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyHover);
export default __webpack_public_path__ + "static/media/CopyHover.b6197bab161e3211d3c989bd675ecac6.svg";
export { ForwardRef as ReactComponent };